module.exports = __webpack_public_path__ + "img/star-hulf.10e5b1e7.svg";